import * as types from '../actions/preferences/types';


const INITIAL_STATE = [];

export default function locationsReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.LOCATIONS_PREFERENCES:

      return action.payload;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/locationsReducer.js